import { render, staticRenderFns } from "./PhotoTextBlock.vue?vue&type=template&id=04e2b43e&scoped=true&"
import script from "./PhotoTextBlock.vue?vue&type=script&lang=ts&"
export * from "./PhotoTextBlock.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoTextBlock.vue?vue&type=style&index=0&id=04e2b43e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e2b43e",
  null
  
)

export default component.exports